import { combineReducers } from 'redux';
import help from './help';
import refund from './refund';

export default combineReducers({ help, refund });
